
import { extendJquery,validateEmail } from "./scripts/utils";
import skipLinkFocusFix from "./scripts/skip-link-focus-fix";
import navigation from "./scripts/navigation";
import modal from "./scripts/modal";

skipLinkFocusFix();
extendJquery();

navigation();
modal();

(function($){
    $(document).ready(function(){
        // parallax des bannières
        $('.with-parallax').each(function(){
            $(this).children('img').parallax($(this),4,0);
        });
        // parallax de la bannière générale
        if($('.banner-parallax').length){
            $('.banner-parallax img').parallax($('.banner'),4,0);
        }

        $('.schema-faq-question').click(function(){
            console.log($(this).parent());
            $(this).parent().toggleClass('open').find('.schema-faq-answer').slideToggle();
        });

        $.fn.isInViewport = function() {
            let elementTop = $(this).offset().top;
            let elementBottom = elementTop + $(this).outerHeight();
        
            let viewportTop = $(window).scrollTop();
            let viewportBottom = viewportTop + $(window).height();
        
            return elementBottom > viewportTop && elementTop < viewportBottom;
        };

        //Animation des quart-cercles
        var speedRotate = -55;
        $(window).on("scroll", function(){
            const scrollValue = $(this).scrollTop() / $(this).height()  * speedRotate;

            $('body').css('--scrollValueRight', -scrollValue);
            $('body').css('--scrollValueLeft', scrollValue);
        })
       

        if($('.container-slider-partners').length != 0){

            let sliderNews = tns({
                container: '.container-slider-partners',
                items: 3,
                nav: 0,
                touch: 1,
                mouseDrag: 1,
                controls: 1,
                controlsText: ['<i class="fa-light fa-circle-arrow-left"></i>', '<i class="fa-light fa-circle-arrow-right"></i>'],
                gutter: 20,
                edgePadding: -100,
                responsive: {
                678: {
                    items: 3
                },
                1050: {
                    edgePadding: -250,
                    items: 6                
                }
                }
            });

            let dragMoveNews = false;
            sliderNews.events.on('dragEnd', function (info) {
                dragMoveNews = false;
                $('.tns-item').each(function(){;
                    $(this).removeClass('no-click');
                })
            });
            
            sliderNews.events.on('dragMove', function (info) {
                dragMoveNews = true;
                $('.tns-item').each(function(){
                    $(this).addClass('no-click');
                })
            });
        }

        if($('.container-news').length != 0){

            let slider = tns({
                container: '.container-news',
                items: 1.2,
                nav: 0,
                touch: 1,
                mouseDrag: 1,
                controls: 0,
                responsive: {
                1050: {
                    items: 3               
                }
                }
            });

            let dragMove = false;
            slider.events.on('dragEnd', function (info) {
                dragMove = false;
                $('.tns-item').each(function(){;
                    $(this).removeClass('no-click');
                })
            });
            
            slider.events.on('dragMove', function (info) {
                dragMove = true;
                $('.tns-item').each(function(){
                    $(this).addClass('no-click');
                })
            });
        }

        if($('.phrases-engagement').length != 0){

            let sliderEngagement = tns({
                container: ".phrases-engagement",
                items: 1,
                autoplay: true,
                autoplayButtonOutput: false,
                nav: false,
                autoHeight: true,
                controls: false,
                lazyload: true,
                speed: 500,
                mouseDrag: false,
                infinite: true,
                fixedWidth: false,
                gutter: 50,
            });

            // $(window).bind('mousewheel',function(event){
            //     let infoSlider = sliderEngagement.getInfo();
            //     let itemsSlider = infoSlider.slideCount;
            //     if ($('.container-engagement').isInViewport()) {
            //         if(itemsSlider != infoSlider.displayIndex && infoSlider.displayIndex != 1){
            //             $('body').css('overflow', 'hidden');
            //         }
            //         else{
            //             $('body').css('overflow', 'auto');
            //         }

            //         if(event.originalEvent.wheelDelta /120 > 0) {
            //             sliderEngagement.goTo('prev');
            //         }
            //         else{
            //             sliderEngagement.goTo('next');
            //         }
            //     }
            // });
        }
    });

    initializeBlockDonation();

     /* inscription a l'infolettre */
     $('.infolettre, .newsletter-form').submit(function(e){
        e.preventDefault();
        let messageLog = $(this).find('.error-log');
        if(!validateEmail($(this).find('input[name="email"]').val())){
            messageLog.text(siteData.traduction.emailError).removeClass('success').addClass('error').show();
        }else{
            // update user interface
            messageLog.html(siteData.traduction.emailProcessing).removeClass('success error').show();
            let data = {
                email: $(this).find('input[name="email"]').val(),
                lang: siteData.lang
            }

            wp.apiFetch({
                path: "codems/newsletter/subscription",
                method: 'POST',
                data: data
            }).then( res => {
                if(res.success){				
                    messageLog.removeClass('error').addClass('success').html(res.message);
                    
                }else{
                    messageLog.removeClass('success').addClass('error').html(res.message);
                }
            })
            
            return false;
        }
    });

    function initializeBlockDonation(){
        let containerBlock = $('.container-donation');
        let prev = containerBlock.prev();
        
        containerBlock.children(".background-donation").css('background-color', prev.css('background-color'));
    }
    
})(jQuery);